import React, { Component } from "react";
import styled from "styled-components";
import { cloud } from "@vitalsource/vstui/colors";

const Styled = {
  OuterContainer: styled.div`
    position: relative;
    display: inline-block;
  `,
  BackgroundContainer: styled.div<{
    isOpen: boolean;
    expandedWidth: number;
    height: number;
  }>`
    position: relative;
    width: ${props =>
      (props.isOpen ? props.expandedWidth : props.height) / 10}rem;
    height: ${props => props.height / 10}rem;
    border-radius: ${props => props.height / 10}rem;
    top: 0;
    right: 0;
    transition: width 200ms;
    background: ${cloud.getShade(1)};
    border: 1px solid ${cloud.getShade(4)};
  `,
  ContentContainer: styled.div`
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  `,
};

interface ExpandingLozengeProps {
  isOpen: boolean;
  onOpenComplete?: () => void;
  onCloseComplete?: () => void;
  expandedWidth: number;
  height: number;
  role?: string;
  "aria-label"?: string;
}

class ExpandingLozenge extends Component<ExpandingLozengeProps> {
  transitionItem: Node | null = null;

  state = {
    isOpen: false,
  };

  componentDidMount(): void {
    if (this.props.isOpen) {
      setTimeout(() => {
        this.setState({ isOpen: true });
      }, 0);
    }

    if (this.transitionItem instanceof Node) {
      this.transitionItem.addEventListener(
        "transitionend",
        this.handleTransitionEvent
      );
    }
  }

  componentWillReceiveProps(nextProps: ExpandingLozengeProps) {
    this.setState({
      isOpen: nextProps.isOpen,
    });
  }

  componentWillUnmount(): void {
    if (this.transitionItem instanceof Node) {
      this.transitionItem.removeEventListener(
        "transitionend",
        this.handleTransitionEvent
      );
    }
  }

  handleTransitionEvent = () => {
    let fn = this.props.onCloseComplete;
    if (this.props.isOpen) {
      fn = this.props.onOpenComplete;
    }
    if (fn) {
      fn();
    }
  };

  render() {
    return (
      <Styled.OuterContainer>
        <Styled.BackgroundContainer
          isOpen={this.state.isOpen}
          height={this.props.height}
          expandedWidth={this.props.expandedWidth}
          innerRef={el => (this.transitionItem = el)}
        />
        <Styled.ContentContainer
          role={this.props.role}
          aria-label={this.props["aria-label"]}
        >
          {this.props.children}
        </Styled.ContentContainer>
      </Styled.OuterContainer>
    );
  }
}

export default ExpandingLozenge;
